export class PrintPage {
    constructor({images, page, frameSize: {width, height}}) {
        this.images = images;
        this.page = page;
        this.maxPages = 20;
        this.frameSize = {width: width, height: height};
        this.rotate = false; // calculate image per page by image height 

        this.imagesSerialized = this.serialize();

        this.imagesForPrint = this.sumImagesForPrint();
        this.imagesPerPage = this.calculateImagesPerPage();

        this.pages = this.imagesForPrint / this.imagesPerPage;
        this.surplus = this.imagesForPrint % this.imagesPerPage;

        this.limitPages();
    }

    static framePerPage({page: {width, height}, frame: {x, y}}) {
        // by image width
        const inWidthX = Math.floor(width / x);
        const inHeightX = Math.floor(height / y);
        const imagePerPageX = inWidthX * inHeightX;

        // by image height
        const inWidthY = Math.floor(width / y);
        const inHeightY = Math.floor(height / x);
        const imagePerPageY = inWidthY * inHeightY;

        let rotate = false;
        let count = imagePerPageX;

        if(imagePerPageY > imagePerPageX) {
            rotate = true;
            count = imagePerPageY;
        }

        return {
            count: count,
            rotate: rotate
        }
    }

    calculateImagesPerPage() {
        const {count, rotate} = PrintPage.framePerPage({
            page: this.page,
            frame: {
                x: this.frameSize.width,
                y: this.frameSize.height
            }
        });

        this.rotate = rotate;
        return count;
    }

    /**
     * limit the number of pages for print to this.maxPages
     * too much pages cause to printer crashing
     */
    limitPages() {
        const {maxPages, pages, imagesPerPage} = this;

        if(pages > maxPages) {
            const surplusPages = Math.floor(pages - maxPages);
            this.surplus += surplusPages * imagesPerPage;
        }
    }
    
    serialize() {
        return this.images.map((item) => {
            return {
                print: Math.max(item.copies - item.printed, 0),
                id: item._id
            }
        }).filter(item => item.print !== 0);
    }

    sumImagesForPrint() {
        return this.images.reduce((accumulator, item) => accumulator += Math.max(item.copies - item.printed, 0), 0);
    }

    drop() {
        const {surplus, imagesSerialized} = this;
        if(this.surplus === 0) return false;

        const resSubArray = this.findSubArrayWithGivenSum(surplus, imagesSerialized);
        if(resSubArray) return resSubArray.map(item => item.id);
        return false;
    }

    split() {
        const {surplus, imagesSerialized} = this;
        if(surplus === 0) return false;

        let surplusCounter = surplus;
        const drop = [];

        const images = [].concat(imagesSerialized); // copy

        while(images.length > 0) {
            let splitMe = images.pop();

            if(surplusCounter >= splitMe.print){
                surplusCounter -= splitMe.print;
                drop.push(splitMe.id);

            } else {
                let print = splitMe.print - surplusCounter;

                return {
                    drop: drop,
                    id: splitMe.id,
                    print: print 
                }
            }
        }
    }

    fullPage() {
        console.log('here');
        if(this.pages < 1) return false;

        const drop = this.drop();
        if(drop) return this.imagesSerialized.filter(item => drop.indexOf(item.id) < 0);

        const split = this.split();
        if(split) {
            const images = this.imagesSerialized.filter(item => split.drop.indexOf(item.id) < 0 && item.id !== split.id);
            images.push({
                id: split.id,
                print: split.print
            });
            
            return images
        }

        if(this.surplus === 0) return this.imagesSerialized;
    }

    all() {
        return this.imagesSerialized;
    }

    /**
     * @source https://www.geeksforgeeks.org/find-subarray-with-given-sum-in-array-of-integers/
     * @param {Number} sum 
     * @param {this.serialize} imagesSerialized 
     */
    findSubArrayWithGivenSum(sum, imagesSerialized) {
        const map = new Map();
        const res = [];
        let current_sum = 0;

        for(let i = 0 ; i < imagesSerialized.length ; i++) {
            current_sum += imagesSerialized[i].print;

            if(current_sum === sum) {
                for(let j = 0 ; j <= i ; j++) res.push(imagesSerialized[j]);
                return res;
            } 

            if(map.has(current_sum - sum)) {
                for(let j = map.get(current_sum - sum) + 1 ; j <= i ; j++) res.push(imagesSerialized[j]);
                return res;
            }

            map.set(current_sum, i);
        } 

        return false;
    }
}


// WEBPACK FOOTER //
// ./src/helper/printPage.js